import ProgressBar from './Progress.vue';
import store from './store';
import Vue from 'vue';

const Progress = Vue.component('ProgressBar', ProgressBar);

export default { Progress, store };
